import LeftArrow from '../images/left-arrow.png'
import EditTextFile from '../images/edit-text-file.png'
import clearMemory from '../images/clear_memory.png'
import './sidenav.css'
import { useState } from 'react'
import { authFetch, getDomain } from '../utils/apis/api'

const Sidenav = ({
  isExpanded,
  toggleExpanded,
  changeChatContentState,
  showSidenav,
  setShowSidenav,
}) => {
  const [previousContents] = useState([])

  const handleNewChatClick = () => {
    changeChatContentState(true)
    sessionStorage.setItem('thread_id', 'null')
    // Check if the screen width is less than or equal to 768px (small screens)
    if (window.innerWidth <= 768) {
      toggleExpanded(false) // Collapse the sidenav
      setShowSidenav(false) // Hide the sidenav
    }
  }

  const handleClearMemory = async () => {
    try {
      changeChatContentState(true);
      sessionStorage.setItem("thread_id", "null");

      const response = await authFetch(`${getDomain()}memories`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to clear memories");
      }

    } catch (err) {
      console.error("Error clearing memories:", err);
    }

    if (window.innerWidth <= 768) {
      toggleExpanded(false);
      setShowSidenav(false);
    }
  };



  // Conditionally render the Sidenav based on showSidenav state
  if (!showSidenav) {
    return null // Return null if Sidenav is not supposed to be visible
  }

  return (
    <div className={`SidenavMain ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="d-flex justify-content-between">
        {/* Expand/Collapse button for larger screens */}
        <button className="TransButton toggle-btn" onClick={toggleExpanded}>
          <img
            src={LeftArrow}
            alt="Toggle"
            style={{
              transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)',
            }}
          />
        </button>

        <div>


          {(isExpanded || window.innerWidth <= 768) && (
            <button onClick={handleNewChatClick} className="TransButton">
              <img src={EditTextFile} width="30" alt="New Chat" />
            </button>
          )}

          {/* {(isExpanded || window.innerWidth <= 768) && (
            <button onClick={handleClearMemory} className="TransButton">
              <img src={clearMemory} width="30" alt="Clear Memory" />
            </button>
          )} */}

        </div>

      </div>

      {(isExpanded || window.innerWidth <= 768) && (
        <div>
          <div className="SubHeading">Previous Conversations</div>
          <div className="PreviousContents">
            {previousContents.map((content, index) => (
              <div className="contents" key={index}>
                {content}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Sidenav
